module.exports = __webpack_public_path__ + "static/media/filter.4976cebe.svg";